import { styled } from '@mui/material/styles';

export const StyledInlineLayout = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '16px',
    textWrap: 'nowrap',
  },
}));
